import { IPrice } from '../IPrice';
import { Price } from '../Price';
import { assertSameCurrency } from './assertSameCurrency';

export function getDifference(a: IPrice, b: IPrice): IPrice {
	assertSameCurrency(a, b);

	return new Price({
		currencyCode: a.currencyCode,
		centAmount: a.centAmount - b.centAmount,
	});
}
